import React from 'react';
import { ImageIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/** Placeholder shown in an agent bubble while a text_to_image turn is still running. */
export const GeneratedImageSkeleton: React.FC = () => {
  const { t } = useTranslation();
  const label = t('chat.generatingImage');

  return (
    <div
      role="status"
      aria-label={label}
      className="flex aspect-square w-48 max-w-full animate-pulse flex-col items-center justify-center gap-2 rounded-md bg-gray-200 text-gray-400 dark:bg-slate-700 dark:text-slate-500 sm:w-56"
    >
      <ImageIcon size={28} />
      <span className="text-xs">{label}</span>
    </div>
  );
};
